<template>
  <el-dialog
    title="上传报告"
    :visible.sync="visible"
    width="690px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose"
  >
    <el-form
      ref="ruleForm"
      :model="result"
      :rules="rules"
      label-width="130px">
      <el-form-item
        label="企业名称：">
        {{ result.vendorName }}
      </el-form-item>
      <el-form-item
        label="套餐：">
        {{ result.package }}
      </el-form-item>
      <el-form-item
        label="结果报告："
        prop="reportFile">
        <upload-with-file
          v-model="result.reportFile"
          :autoCropWidth="100"
          :autoCropHeight="100"
          :limit="10" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadWithFile from '../../components/public/upload-with-crop'
export default {
  name: 'EditResultModal',
  components: { UploadWithFile },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      result: {
        workOrderId: null,
        reportFile: []
      },
      rules: {
        reportFile: [
          { required: true, message: '请上传报告', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(`account/completionworkorder`, {
            payload: {
              workOrderId: this.result.workOrderId,
              reportFile: this.result.reportFile
                .map((o) => o.url)
                .join(',')
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    init(options = {}) {
      this.result = {
        ...this.result,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
